/** Coerce API rating averages (camelCase, PascalCase, or string) to a finite number or null. */
export function normalizeRatingAverage(raw: unknown): number | null {
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
  if (typeof raw === 'string' && raw.trim() !== '') {
    const n = Number(raw);
    if (Number.isFinite(n)) return n;
  }
  return null;
}

/** One decimal place for learner/admin rating labels; null when value is missing. */
export function formatRatingOneDecimal(raw: unknown): string | null {
  const avg = normalizeRatingAverage(raw);
  if (avg == null) return null;
  return (Math.round(avg * 10) / 10).toFixed(1);
}

/** Read average from rating-summary DTOs regardless of JSON casing. */
export function ratingAverageFromSummary(summary: unknown): number | null {
  if (!summary || typeof summary !== 'object') return null;
  const s = summary as Record<string, unknown>;
  return normalizeRatingAverage(s.averageRating ?? s.AverageRating);
}
